import React from 'react';
import { sanitizeHTML } from '@benzinga/frontend-utils';
import styles from './styles.module.scss';

export interface QAProps {
  answer: React.ReactNode | string;
  question: string;
  variant?: 'default' | 'cards';
}

const LetterIcon = ({ letter }: { letter: string }) => <div className={styles['qa-letter-icon']}>{letter}</div>;

export const QA = ({ answer, question, variant = 'default' }: QAProps) => {
  const answerNode =
    typeof answer === 'string' ? (
      <div className={styles['answer-container']} dangerouslySetInnerHTML={{ __html: sanitizeHTML(answer) }} />
    ) : (
      <div className={styles['answer-container']}>{answer}</div>
    );

  if (variant === 'cards') {
    return (
      <div className={styles['qa-card']}>
        <LetterIcon letter="Q" />
        <div className={styles['qa-card-text']}>
          <h3 className={styles['question']}>{question}</h3>
          {answerNode}
        </div>
      </div>
    );
  }

  return (
    <div className={styles['qa-container']}>
      <div className={styles['qa-header']}>
        <LetterIcon letter="Q" />
        <h3 className={styles['question']}>{question}</h3>
      </div>
      <div className={styles['qa-body']}>
        <LetterIcon letter="A" />
        {answerNode}
      </div>
    </div>
  );
};
